<template>
  <div class="news-center">
    <div class="us_header">
      <div class="title_main"></div>
    </div>
    <div class="tabs"><div class="text">一图四清单</div></div>
    <div class="wrapper">
      <div class="title">“ 一图四清单 ”</div>
      <div class="desc">
        工信部推动制造业数字化转型的核心方法论，通过场景图谱与要素清单的系统化结合，为行业提供精准转型路径。
      </div>
      <div class="content">
        <el-row :gutter="12">
          <el-col :span="8" :key="item.id" v-for="item in lists">
            <el-card shadow="hover" style="margin: 6px 0">
              <div
                @click="goToDetail(item.id)"
                style="display: flex; align-items: center;cursor: pointer;"
              >
                <img
                  width="24"
                  src="../../../assets/image/file.png"
                />&nbsp;&nbsp;
                <div style="line-height: 19px; color: #0052d9">
                  {{ item.name }}
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <left-float-btn></left-float-btn>
  </div>
</template>
<script>
import newsList from "./newsList.vue";
import LeftFloatBtn from "../../../components/LeftFloatBtn";
export default {
  name: "newsCenter",
  components: {
    LeftFloatBtn,
    newsList,
  },
  data() {
    return {
      currentIndex: 0,
      title: [],
      type: "",
      time1: null,
      time2: null,
      lists: [
        {
          id: 1,

          name: "01-钢铁行业",
        },
        {
          id: 2,

          name: "02-石化行业",
        },
        {
          id: 3,

          name: "03-船舶行业",
        },
        {
          id: 4,
          name: "04-工程机械行业",
        },
        {
          id: 5,
          name: "05-新能源汽车行业",
        },
        {
          id: 6,
          name: "06-机器人行业",
        },
        {
          id: 7,
          name: "07-医疗装备行业",
        },
        {
          id: 8,
          name: "08-家电行业",
        },
        {
          id: 9,
          name: "09-制糖行业",
        },
        {
          id: 10,
          name: "10-白酒行业",
        },
        {
          id: 11,
          name: "11-美妆日化行业",
        },
        {
          id: 12,
          name: "12-锂电行业",
        },
        {
          id: 13,
          name: "13-印刷电路板(PCB)行业",
        },
        {
          id: 14,
          name: "14-智能移动终端行业",
        },
        {
          id: 15,
          name: "15-民爆行业",
        },
        {
          id: 16,
          name: "16-建材行业",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    goToDetail(id) {
      console.log("点击了");
      this.$router.push({
        path: "/digitalTransformateDetail",
        query: { id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news-center {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .new-detail {
    width: 900px;
    border-radius: 6px;
    margin-left: 16px;
  }
}
.tabs {
  background-color: #ffffff;
  height: 50px;
  .text {
    margin-left: 20%;
    line-height: 47px;
    width: fit-content;
    height: 47px;
    border-bottom: 2px solid #1e4da5;
    // font-size: 36px;
  }
}
.wrapper {
  width: 100%;
  background: #f5f7fd;
  padding: 0px 20%;
  margin-bottom: 20px;
  .title {
    display: flex;
    justify-content: center;
    font-size: 30px;
    padding: 12px 0;
    font-weight: 700;
  }
  .desc {
    color: #909194;
    font-size: 14px;
    text-align: center;
    margin: 12px 0;
  }
  .content {
    font-weight: 600;
    // color: #214fa6;
  }
}
.us_header {
  background: url("../../../assets/image/bg.jpg") no-repeat;
  background-size: cover;
  // background-size: 100% 100%;
  width: 100%;
  height: 520px;
  position: relative;

  .title_main {
    position: absolute;
    left: 18.7%;
    top: 252px;

    .title_line {
      width: 68px;
      height: 8px;
      background: #ffffff;
      opacity: 1;
    }

    .zh_title {
      font-family: "Microsoft YaHei Bold";
      font-weight: 700;
      font-size: 38px;
      text-align: left;
      color: #16181a;

      margin-top: 25px;
      margin-bottom: 18px;
    }

    .eg_title {
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 18px;
      color: #000;
      margin-top: 42px;
    }
  }
}
.new-type {
  width: 16%;
  min-height: 194px;
  background: #ffffff;
  opacity: 1;
  height: 100%;
  border-radius: 6px;
  .tab-control-item {
    // padding-top: 5px;
    cursor: pointer;
  }
  .tab-control-item div {
    // margin-top: 10px;
    min-height: 42px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 8px 12px;
    font-family: Microsoft YaHei;

    color: #16181a;
  }
  div :hover {
    background: rgba(0, 82, 217, 0.1);
    color: rgba(0, 82, 217, 1);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 600;
  }
  .active div {
    background: rgba(0, 82, 217, 0.1);
    color: rgba(0, 82, 217, 1);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 600;
  }
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  background: #0052d9;
}
/deep/ .el-card {
  color: #0052d9 !important;
}
/deep/ .el-card__body:hover {
  div {
    color: #ffffff !important;
    cursor: pointer;
  }
}
</style>
